var EventEmitter = /** @class */ (function () {
    function EventEmitter() {
        this.events = {};
    }
    EventEmitter.prototype.subscribe = function (name, fn) {
        if (!this.events[name]) {
            this.events[name] = [];
        }
        if (!this.events[name].includes(fn)) {
            this.events[name].push(fn);
        }
    };
    EventEmitter.prototype.on = function (name, fn) {
        return this.subscribe(name, fn);
    };
    EventEmitter.prototype.emit = function (name, data) {
        if (this.events[name]) {
            for (var _i = 0, _a = this.events[name]; _i < _a.length; _i++) {
                var fn = _a[_i];
                fn(data);
            }
        }
    };
    return EventEmitter;
}());
export { EventEmitter };
